import { Button } from "@/components/ui/button";
import { ArrowDownToLine } from "lucide-react";
import { motion } from "framer-motion";

interface ExportButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export function ExportButton({ onClick, disabled = false }: ExportButtonProps) {
  return (
    <motion.div
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.96 }}
    >
      <Button
        variant="outline"
        size="icon"
        onClick={onClick}
        disabled={disabled}
        className="h-8 w-8 border border-border bg-background hover:bg-accent hover:border-primary group transition-colors"
        title="Export data"
        type="button"
      >
        <ArrowDownToLine className="h-4 w-4 text-foreground dark:text-gray-200 group-hover:text-primary transition-colors" />
        <span className="sr-only">Export data</span>
      </Button>
    </motion.div>
  );
}

export default ExportButton; 